<template>
<!-- 灰度任务详情 -->
  <div class="upgrade-page">
    <el-tabs v-model="activeName" class="tabs">
      <el-tab-pane :label="$t('button.grayscaleConfig')" name="GrayscaleConfig" class="tabs-content">
        <GrayscaleConfig :formalUpgradeInfo="formalUpgradeInfo"/>
      </el-tab-pane>
      <el-tab-pane
        :label="$t('pages.equipment.text211')"
        name="GrayscaleSituation"
        class="tabs-content"
      >
        <GrayscaleSituation :activeName="activeName" :formalUpgradeInfo="formalUpgradeInfo"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import GrayscaleConfig from "./module/GrayscaleConfig.vue";
import GrayscaleSituation from "./module/GrayscaleSituation.vue";
export default {
  data() {
    return {
      activeName: null,
      params: {
        id: "", //主键id
        taskType:'0'
      },
      formalUpgradeInfo: {},
    };
  },
  mounted() {
    this.params.id = this.$route.query.id;
    this.activeName = "GrayscaleConfig";
    this.grayScaleTestInfo();
  },
  components: {
    GrayscaleConfig,
    GrayscaleSituation,
  },
  methods: {
    //灰度详情
    grayScaleTestInfo(e){
      this.params = {...this.params,...e}
      this.request.grayScaleTestInfo(this.params).then((res)=>{
        this.formalUpgradeInfo = res.data
      })
    }
  },
};
</script>

<style scoped>
.upgrade-page {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.tabs-content {
  width: 100%;
  height: 100%;
}
</style>